import { useEffect, useState } from "react";
import {
    HouseholdTrackingEligibility,
    HouseholdTrackingGroup
} from "../../models/pageModels/HouseholdTracking";
import Button from "../UI/Button";
import Checkbox from "../UI/Checkbox";
import WarningMessages from "../UI/WarnginMessages";
import HouseholdTrackingReview from "./HouseholdTrackingReview";
import "./HouseholdTracking.css";

interface HouseholdTrackingControlsProps {
    groups: HouseholdTrackingGroup[];
    eligibility: Record<string, HouseholdTrackingEligibility>;
    loadingEligibility: boolean;
    programName: string;
    selectedClientIds: string[];
    checked: boolean;
    disabled: boolean;
    onChange: (checked: boolean) => void;
    onSelectedClientIdsChange: (clientIds: string[]) => void;
}

const HouseholdTrackingControls = (props: HouseholdTrackingControlsProps) => {
    const [expanded, setExpanded] = useState(false);
    const hasHouseholdMembers = props.groups.length > 0;
    const householdMemberCount = new Set(
        props.groups.flatMap(group => group.people.map(person => person.clientId || person.key))
    ).size;

    useEffect(() => {
        setExpanded(props.checked);
    }, [props.checked]);

    return (
        <div className="household-tracking-controls">
            <div className="row align-items-center">
                <div className="column-auto">
                    <Checkbox id="submit-for-household"
                        checked={props.checked}
                        disabled={props.disabled || !hasHouseholdMembers}
                        label="Also submit this form for eligible household participants"
                        onChange={props.onChange} />
                </div>
                {hasHouseholdMembers && props.checked && <div className="column-auto household-tracking-toggle">
                    <Button id="toggle-household-members"
                        className="secondary small"
                        text={`${expanded ? "Hide Household Members" : "Show Household Members"} (${householdMemberCount})`}
                        icon={expanded ? <i className="ri-arrow-up-s-line" /> : <i className="ri-arrow-down-s-line" />}
                        iconLocation="end"
                        disabled={props.disabled || !props.checked}
                        onClick={() => setExpanded(current => !current)} />
                </div>}
            </div>
            {!hasHouseholdMembers && <WarningMessages
                showIcon={true}
                messageClassName="prominent"
                messages={["Household submission is unavailable because this participant has no household members."]} />}
            {props.checked && expanded && <HouseholdTrackingReview
                groups={props.groups}
                eligibility={props.eligibility}
                loading={props.loadingEligibility}
                programName={props.programName}
                selectedClientIds={props.selectedClientIds}
                disabled={props.disabled || props.loadingEligibility}
                onSelectedClientIdsChange={props.onSelectedClientIdsChange} />}
        </div>
    );
};

export default HouseholdTrackingControls;
